const vendor = {
  modal: {
    editVendor: 'Редагувати запис',
    exportVendor: 'Експорт',
    storeVendor: 'Додати новий запис',
    share: 'Поділитися',
    store: 'Магазин',
    vendor: 'Постачальник',
    country: 'Країна',
    mature: 'Зрілий',
    products: 'Товари',
    successUpdate: 'Існуючий запис успішно оновлено',
    successStore: 'Новий запис успішно додано',
    exportVendorsLoading: 'Завантаження експортованих постачальників...',
  },
  page: {
    adminVendors: 'Постачальники адміністратора',
    adminVendorsOptions: 'Параметри постачальників адміністратора',
    showing: 'показується',
    vendorsOf: 'постачальники з',
    noVendorsFound: 'Постачальників не знайдено',
  },
  tableDropdown: {
    quickActions: 'Швидкі дії',
    refresh: 'Оновити',
    exportVendors: 'Експорт',
    prepareExportVendors: 'Підготувати експорт',
  },
  actionsDropdown: {
    edit: 'Редагувати',
    delete: 'Видалити',
  },
  messages: {
    vendorDeleted: 'Постачальника успішно видалено',
    vendorUpdated: 'Постачальника успішно оновлено',
  }
};

export default vendor;
